import { useContext } from 'react'
import { GlobalContext } from 'src/components/layout/GlobalContext'

export const useCurrentLocale = () => {
  const context = useContext(GlobalContext)

  return context.currentLocale
}
